import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-create-ledger-dialog',
    templateUrl: './create-ledger-dialog.component.html',
    styleUrls: ['./create-ledger-dialog.component.scss'],
    standalone: false
})
export class CreateLedgerDialogComponent implements OnInit {

  form: UntypedFormGroup;
  name: string;
  description: string;

  constructor(
    private fb: UntypedFormBuilder,
    private dialogRef: MatDialogRef<CreateLedgerDialogComponent>
  ) { 
  }

  ngOnInit() {
    this.form = this.fb.group({
      name: [this.name, [Validators.required]],
      description: [this.description, []]
    })
  }

  save() {
    this.dialogRef.close(this.form.value);
  }

  close() {
    this.dialogRef.close();
  }

}
